import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function HotStreakIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3459">
      <div className="relative w-full h-full bg-gradient-to-br from-blue-600 to-purple-800 overflow-hidden" data-id="element-3460">
        {/* Background: Speed lines and lightning */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3461">
          {/* Speed lines */}
          <path d="M-20 40 L100 40" stroke="#60A5FA" strokeWidth="4" strokeLinecap="round" strokeDasharray="20 40" opacity="0.5" data-id="element-3462" />
          <path d="M-50 80 L120 80" stroke="#A78BFA" strokeWidth="6" strokeLinecap="round" strokeDasharray="40 30" opacity="0.4" data-id="element-3463" />
          <path d="M-10 120 L80 120" stroke="#38BDF8" strokeWidth="3" strokeLinecap="round" strokeDasharray="15 25" opacity="0.6" data-id="element-3464" />
          <path d="M-40 160 L140 160" stroke="#818CF8" strokeWidth="5" strokeLinecap="round" strokeDasharray="30 50" opacity="0.5" data-id="element-3465" />

          {/* Lightning bolts */}
          <path d="M140 20 L130 60 L150 60 L120 110" stroke="#FDE047" strokeWidth="3" strokeLinejoin="round" fill="none" opacity="0.8" data-id="element-3466" />
          <path d="M170 80 L160 110 L175 110 L150 150" stroke="#FEF08A" strokeWidth="2" strokeLinejoin="round" fill="none" opacity="0.6" data-id="element-3467" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pl-[15%]" data-id="element-3468">
          <div className="w-[65%] h-[65%] flex items-center justify-center transform -rotate-12" data-id="element-3469">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} variant={variant} accessory="smallFlame" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3470" />
          </div>
        </div>

        {/* Foreground: Motion blur/trail */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3471">
            <path d="M20 100 Q60 80 100 100 Q60 120 20 100 Z" fill="#FDE047" opacity="0.2" filter="blur(8px)" data-id="element-3472" />
            <path d="M40 100 Q70 90 100 100 Q70 110 40 100 Z" fill="#60A5FA" opacity="0.3" filter="blur(4px)" data-id="element-3473" />

            {/* Sparks */}
            <circle cx="120" cy="140" r="2" fill="#FDE047" data-id="element-3474" />
            <circle cx="90" cy="160" r="1.5" fill="#38BDF8" data-id="element-3475" />
            <circle cx="150" cy="70" r="2.5" fill="#FDE047" data-id="element-3476" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}